var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-dialog',{attrs:{"title":"收货地址","visible":_vm.value},on:{"update:visible":function($event){_vm.value=$event}}},[_c('address-save',{attrs:{"addressData":_vm.addressData},on:{"submitSuccess":function($event){return _vm.submit('submitSuccess', $event)},"submitError":function($event){return _vm.submit('submitError', $event)}}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }